import React from 'react';

import { View } from 'react-native';

import { EPGChannel } from 'custom_modules/react-native-epg';

import { CHANNEL_LIST_ITEM_ID } from 'config/testID';

import useShowImage from 'utils/hooks/useShowImage';

import NagraImage from 'components/NagraImage';
import {
    AspectRatio,
    ImageContentType,
    ImageType,
} from 'components/NagraImage/types';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import { EpgChannelExtra } from '../../types';
import styles from './styles';

type Props = {
    channelItem: EPGChannel<EpgChannelExtra>;
    playing?: boolean;
    isChannelSubscribed?: boolean;
};

function EpgChannel({ channelItem, playing, isChannelSubscribed }: Props) {
    const { id, name } = channelItem;

    const {
        showImage: showChannelLogo,
        onImageLoad,
        onImageLoadError,
    } = useShowImage();

    return (
        <View
            aria-selected={playing}
            style={styles.root}
            testID={`${CHANNEL_LIST_ITEM_ID}_${name}`.replace(/ /g, '')}
        >
            {playing && <View style={styles.selected} />}
            <View style={styles.logoBlock}>
                {!!id && showChannelLogo && (
                    <NagraImage
                        style={styles.logo}
                        resizeMode="contain"
                        contentId={id}
                        imageType={ImageType.LOGO}
                        contentType={ImageContentType.CHANNEL}
                        aspect={AspectRatio.LANDSCAPE}
                        height={32}
                        onLoad={onImageLoad}
                        onError={onImageLoadError}
                    />
                )}
                {name && !showChannelLogo && (
                    <Text
                        numberOfLines={2}
                        color={ETextColor.neutral}
                        category={ETextCategory.caption2}
                        style={styles.channelName}
                        bold
                    >
                        {name}
                    </Text>
                )}
            </View>
            {!isChannelSubscribed && (
                <View style={styles.unsubscribedOverlay} />
            )}
        </View>
    );
}

export default EpgChannel;
